import React, { Component } from 'react';
import DateRangePicker from 'react-daterange-picker';
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import ClickOutHandler from 'react-onclickout';
import "react-daterange-picker/dist/css/react-calendar.css";
import '../css/calendar.css';

class Calendar extends Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            isOpen: false,
            value: this.props.value
        };

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect = (value, states) => { 
        let numDays = Math.round(value / 86400 / 1000);
        if(numDays === 0){
            return false;
        }
        this.setState({ value, states });
        this.handleToggle();
        if(typeof this.props.onSelect !== 'undefined' && this.props.onSelect !== ''){
            this.props.onSelect(value);
        }
    };

    handleToggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    render() {
        let selectedInterval;    
        let numDays; 
        let calendarValue;     
        if(this.state.value){
            numDays = Math.round(this.state.value / 86400 / 1000);
            selectedInterval = this.state.value.start.format("MM/DD/YYYY")+" - "+this.state.value.end.format("MM/DD/YYYY") + " ("+numDays+" night"+(numDays > 1 ? "s" : "")+")";
            calendarValue = this.state.value;
        }else{
            const moment = extendMoment(originalMoment);
            const today = moment();
            selectedInterval = today.clone().format("MM/DD/YYYY")+" - "+today.clone().add(1, "days").format("MM/DD/YYYY")+" (1 night)";
            calendarValue = moment.range(today.clone().subtract(1, "days"), today.clone().add(1, "days"));
        }
        return (  

                <div>                    
                    <div className="vb-checkin" onClick={this.handleToggle}>{selectedInterval}</div>
                    {this.state.isOpen && (
                        <ClickOutHandler onClickOut={this.handleToggle}>
                            <DateRangePicker
                                value={calendarValue}
                                numberOfCalendars={this.props.numberOfCalendars !== 'undefined' ? this.props.numberOfCalendars : 1}
                                onSelect={this.handleSelect}
                                singleDateRange={true}   
                                firstOfWeek={1} 
                                selectionType="range"
                                minimumDate={new Date()}                                            
                            />
                        </ClickOutHandler>
                    )}        
                </div>               

        );
    }

}

export default Calendar;